import React, { useState, useEffect } from "react";
import "../style/products.css";

// Components
import Filter from "../components/Filter";
import ShowProducts from "../components/ShowProducts";
import Filterstrip from "../components/Filterstrip";

export default function Products() {
  const [params, setParams] = useState();
  const [prodCount, setProdCount] = useState(0);
  // useEffect(() => {
  //   console.log("Params have changed:", prodCount);
  //   // Additional logic to handle params change can go here
  // }, [params, prodCount]); // Run whenever `params` changes
  return (
    <div className="Products">
      <Filterstrip setParams={setParams} productCount={prodCount} />
      <hr />

      {/* <i className='products-title'>Vintage Cameras</i> */}
      {/* <ProductsComponent products="search-product" header="" var="35mm" /> */}
      <ShowProducts param={params} setProdCount={setProdCount} />
    </div>
  );
}
